import { data } from '../../svg/ChevronRight/data';
import { makeIcon } from '../makeIcon';

export const ChevronRight = makeIcon(data, 'chevron_right', 'ChevronRight');

export default ChevronRight;
